
const TableCellText = ({ value }) => {
    return (<p className="text-sm ps-2">{value}</p>)
}

export default TableCellText;